import {
  getAppName, resetOnlogout, setLocalStorageValue,
  valueToObject,
} from 'Utils/UtilityFunctions';
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { getLocalStorageValue, objToFormData } from './UtilityFunctions';
import { API, FEED_ROUTE, RESTRICT_ROUTE } from './Constants';
import { actions as flurryActions } from '../Slice/HelperSlice';
import store from '../Store/store';

const instance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 900 * 1000,
  withCredentials: true,
});

instance.interceptors.request.use(
  async (req: AxiosRequestConfig | any) => {
    req.headers['X-CSRFToken'] = getLocalStorageValue('csrfToken');
    const username = getLocalStorageValue('email');
    if (username && getLocalStorageValue('csrfToken')) {
      if (!req.data) {
        req.data = {};
      }
      if (!req.data.username) {
        req.data.username = getLocalStorageValue('email');
      }
    }
    req.data.appName = getAppName(); // will add a util function to change the source/app name LATER

    // Only convert to FormData if the method is not GET
    if (req.method !== 'get') {
      req.data = objToFormData(req.data);
    }
    return req;
  },
  async (err: any) => Promise.reject(err),
);

instance.interceptors.response.use(
  async (resp: AxiosResponse) => {
    if (resp.status === 200 && localStorage.getItem('restrictFlag') === 'true' && !resp.config.url?.includes(API.GLOBAL_SEARCH_CONTENT) && !resp.config.url?.includes(API.SUPPORTED_LANGUAGE) && !resp.config.url?.includes(API.TRANSLATION_HTML)) {
      localStorage.setItem('restrictFlag', 'false');
      window.location.href = FEED_ROUTE;
    }
    return resp?.data;
  },
  async (error: any) => {
    if (error.response.status === 403) {
      if (error.response.config.url === API.USER_PROFILE) {
        resetOnlogout(window.location.pathname + window.location.search, false, true);
      } else {
        resetOnlogout(window.location.pathname + window.location.search);
      }
    }
    if (error.response.status === 409) {
      const restrictFlag = localStorage.getItem('restrictFlag');
      if (restrictFlag === 'true' && !window.location.href.includes(RESTRICT_ROUTE)) {
        window.location.href = RESTRICT_ROUTE;
      } else {
        localStorage.setItem('restrictFlag', 'true');
        if (!window.location.href.includes(RESTRICT_ROUTE)) {
          window.location.href = RESTRICT_ROUTE;
        }
      }
    }
    if (error.response.status === 504
      && (error.response.config.url === API.GENERATE_EMAIL
        || error.response.config.url === API.COMPANY_CHATBOT
        || error.response.config.url === API.DOCUMENT_HUB_CHATBOT
        || error.response.config.url === API.BUYER_GROUP_CHATBOT)) {
      setLocalStorageValue('timeout', 'true');
      window.dispatchEvent(new Event('storage'));
    }
    if ([500, 501, 502, 503, 504, 509, 511].includes(error.response.status)) {
      store.dispatch(flurryActions.callFlurryEvent(
        valueToObject('internal_server_error', 0, {
          host: window.location.href,
        }),
      ));
    }

    if (error.response.status === 400) {
      store.dispatch(flurryActions.callFlurryEvent(
        valueToObject('client_error_400', 0, {
          host: window.location.href,
        }),
      ));
    }
    return Promise.reject(error.response.data);
  },
);

export default instance;